import { toast } from "react-toastify";

const toastList = new Set();
export default function Toast({ message, type }) {
    const id = toast[type](message, {
        onClose: () => toastList.delete(id)
    });
    toastList.add(id);
};